(function(angular){
	'use strict';
	
	angular
		.module('reitElementListingModule')
		.factory('ReitElementTooltipFactory', [
			'$compile',
			'$rootScope',
			ReitElementTooltipFactoryFunction
		]);
	
	function ReitElementTooltipFactoryFunction(
			$compile,
			$rootScope
		) {
		var factory = {
			buildIpoTooltip: buildIpoTooltip,
			buildReitElementTooltip: buildReitElementTooltip,
			buildRiskRatingTooltip: buildRiskRatingTooltip
		};

		function buildIpoTooltip(ipoPoint) {
			return '<div class="highcharts-tooltip__inner"><div class="font-weight-bold heading-text-color epsilon">The Fundrise iPO</div><div class="eta muted">' + ipoPoint.y +'% of total portfolio</div></div>';
		}

		function buildReitElementTooltip(reitElement) {
			var tooltipScope = $rootScope.$new();
			tooltipScope.reitElement = reitElement;
			var compiledTemplate = $compile('<div class="highcharts-tooltip__inner"><div class="display-flex align-items-center"><div class="delta"><span class="risk-rating-badge" ng-style="{ \'background-color\' : reitElement.rating.color }">{{reitElement.rating.full}}</span></div><div class="pl-50"><div class="zeta heading-text-color font-weight-bold">{{reitElement.projectType}}</div><div class="muted">{{reitElement.city}}, {{reitElement.state}}</div></div></div></div>')(tooltipScope);
			tooltipScope.$digest();
			return compiledTemplate[0].outerHTML;
		}

		function buildRiskRatingTooltip(riskRating) {
			var tooltipScope = $rootScope.$new();
			tooltipScope.riskRating = riskRating;
			var compiledTemplate = $compile('<div class="highcharts-tooltip__inner"><div class="display-flex align-items-center body-text-color epsilon"><span><span class="font-weight-bold heading-text-color">{{riskRating.reitElements.count}}</span> assets rated</span><span class="risk-rating-badge ml-25" ng-style="{ \'background-color\' : riskRating.color }">{{riskRating.name}}</span></div><div class="eta muted">{{riskRating.y}}% of total portfolio</div></div>')(tooltipScope);
			tooltipScope.$digest();
			return compiledTemplate[0].outerHTML;
		}
		
		return factory;
	}
})(window.angular);